import {
  IonButton,
  IonCol,
  IonGrid,
  IonPage,
  IonRow,
} from "@ionic/react";
import { buyLoadShipmentRequest } from "../../../actions/BookLoad/action";
import { GetShipment } from "../../../models/home/GetShipment.model";
import { getAppointmentTime } from "../../../utils/formatData";
import getTime from "../../../utils/getTimePeriod";
import { Breadcrumb } from "../../../web/components/breadcrumb/Breadcrumb";
import { CallUs } from "../../../web/components/call-us/callUs";
import { StopDetailsWithRoute } from "../../../web/components/loadStops/StopDetailsWithRoute";
import React from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";

import "./ExecutionPage.scss";
import { EExecutionStatus } from "../../../utils/constants";

const ExecutionPage: React.FC<any> = (props: any) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { Component } = props;
  const loadDetails = props.shipmentToStartTrip || {};

  const calculateTime = (stop: any) => {
    if (props.isMyload) {
      return getAppointmentTime(stop);
    }
    return getTime(stop.appointmentFrom || "", stop.appointmentTo || "");
  };
  const module = (location.state && (location.state as any).module) || "#";

  const onRefresh = () => {
    const shipmentId = (loadDetails && loadDetails.shipmentId) || "";
    const getShipmentmodel: GetShipment = new GetShipment();
    getShipmentmodel.shipmentIds = shipmentId;
    dispatch(
      buyLoadShipmentRequest({
        query: getShipmentmodel.getRequestShipmentPayload(),
        shipmentId,
        module: module,
        isPullToRefresh: false,
      })
    );
  };
  const executionStatus = props.shipmentToStartTrip && props.shipmentToStartTrip.executionStatus;
  return (
    <React.Fragment>
      <IonPage className="execution-page">
        <IonGrid className="header">
          <IonRow className="bread-cumb-row">
            <IonCol size="12">
              <Breadcrumb
                items={[
                  { name: "My Loads", backUrl: `/app/${module}` },
                  { name: loadDetails.shipmentId, backUrl: "#" },
                ]}
              />
            </IonCol>
          </IonRow>
          <IonRow className="header-action-row">
            <IonCol size="6">
              <h1>{loadDetails.shipmentId}</h1>
            </IonCol>
            <IonCol size="6" className="right">
              <IonButton className="action-refresh" onClick={onRefresh}>
                Refresh
              </IonButton>
            </IonCol>
            <IonCol size="6" className="right"></IonCol>
          </IonRow>

          <IonRow className="header-status-row">
            {/* F39808 */}
            {/* <IonCol
              size="auto"
              className="right left-border clear-right-padding"
            >
              <div className="trip-status">
                Automated Tracking:{" "}
                <span className="active">{`${
                  loadDetails.automatedTrackingInProgress == true ? "ON" : "OFF"
                }`}</span>
              </div>
            </IonCol>
            <IonCol size="auto" className="right left-border">
              <div className="trip-status">{executionStatus==="COMPLETED" ?EExecutionStatus.TRIP_COMPLETED:EExecutionStatus.TRIP_IN_PROGRESS}</div>
            </IonCol> */}
            <IonCol size="auto" className="right">
              <CallUs loadDetails={loadDetails} {...props} />
            </IonCol>
          </IonRow>
        </IonGrid>
        <div className="execution-container">
          <StopDetailsWithRoute
            loadDetails={loadDetails}
            calculateTime={calculateTime}
          />
          <div className="execution-page-details">
            <Component {...props} />
          </div>
        </div>
      </IonPage>
    </React.Fragment>
  );
};

export default ExecutionPage;
